function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "order-success_inline_svg__9rt12me7ca"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.678431 0 0 0 0 0.776471 0 0 0 0 0.792157 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero",
  filter: "url(#order-success_inline_svg__9rt12me7ca)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0C8.952 0 0 8.952 0 20s8.952 20 20 20 20-8.952 20-20S31.048 0 20 0zm12.525 15.75L17.686 30.59a1.291 1.291 0 01-1.824 0l-8.387-8.388a1.29 1.29 0 010-1.824l1.824-1.825a1.29 1.29 0 011.825 0l5.65 5.65 12.102-12.101a1.29 1.29 0 011.825 0l1.824 1.825a1.29 1.29 0 010 1.824z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.686 30.59a1.291 1.291 0 01-1.824 0l-8.387-8.388a1.29 1.29 0 010-1.824l1.824-1.825a1.29 1.29 0 011.825 0l5.65 5.65 12.102-12.101a1.29 1.29 0 011.825 0l1.824 1.825a1.29 1.29 0 010 1.824L17.686 30.59z"
}));

function SvgOrderSuccessinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default SvgOrderSuccessinline;